export * from 'server/models/MarineTrafficResult';


// WEBPACK FOOTER //
// ./data/models/MarineTrafficResult.ts